import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const RCQuakesLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=RCQM_MYTIXX&orgid=54890#/auth/login"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    Quakes MyProVenue Account
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com",
    description: (
      <>
        Click Continue and connect your <RCQuakesLink /> using our secure
        MiLB.com login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <RCQuakesLink /> within 24 hours of
        purchase. Reach out to the Quakes Ticket Department for any questions at
        <Link href="tel:9094815000">(909) 481-5000</Link>.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Quakes Buy More Save More Program work?",
    description:
      "The Quakes Buy More Save More Program allows fans to select Club and/or Field Box seats to select games hosted by the Rancho Cucamonga Quakes. Simply log into your MiLB.com account and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "You can choose seats from available inventory in the Club and Field Box sections.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your <RCQuakesLink />.
      </>
    ),
  },
];
